import React, { useEffect, useRef, useState } from 'react'
import { Settings } from '@mui/icons-material'
import { useAppSelector, useAppDispatch, RootState } from 'store/store'
import { languages } from 'shared/constants/countries'
import { setLanguage } from 'store/reducers/layoutReducer'
import { ELanguage } from 'types/enums/ELanguage'
import {
  ChosenLanguage,
  HamburgerMenuWrapper,
  OtherLanguages,
  StyledButton,
  StyledFlagIcon,
  StyledFlagText,
  StyledLink,
  StyledLinkText,
  StyledLogoutIcon,
  StyledMenuOptions,
  StyledText,
} from './style'
import { Divider } from '@mui/material'
import logoutIcon from 'assets/icons/log-out-02.svg'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

const HamburgerMenu: React.FC = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'components.hamburgerMenu',
  })
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const user = useAppSelector((state) => state.user)
  const languageCode = useSelector(
    (state: RootState) => state.layout.language.code,
  )
  const dispatch = useAppDispatch()
  const isAuthenticated = user.isAuthenticated

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const languageRenderer = () =>
    languages.map((lang) => {
      if (lang.code === languageCode) {
        return (
          <ChosenLanguage
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
          >
            <StyledFlagIcon src={lang.flagImagePath} />
            <StyledFlagText>{lang.code}</StyledFlagText>
          </ChosenLanguage>
        )
      }
      return (
        <OtherLanguages
          key={lang.code}
          onClick={() => handleLanguageChange(lang.code)}
        >
          <StyledFlagIcon src={lang.flagImagePath} />
          <StyledFlagText>{lang.code}</StyledFlagText>
        </OtherLanguages>
      )
    })
  const handleLanguageChange = (languageCode: ELanguage) => {
    dispatch(setLanguage(languageCode))
    setIsOpen(false)
  }

  return (
    <HamburgerMenuWrapper ref={dropdownRef} languagesCode={languageCode}>
      <StyledButton onClick={() => setIsOpen(!isOpen)}>
        <Settings
          style={{
            color: '#000',
            fill: '#000',
          }}
        />
      </StyledButton>

      {isOpen && (
        <StyledMenuOptions languagesCode={languageCode}>
          <StyledText>{t('languages')}</StyledText>
          {languageRenderer()}
          {isAuthenticated && (
            <>
              <Divider
                component="div"
                sx={{ borderBlockEnd: '1px solid #ccc', width: '100%' }}
              />

              <StyledLink to="/logout">
                <StyledLinkText>{t('logout')}</StyledLinkText>
                <StyledLogoutIcon src={logoutIcon} />
              </StyledLink>
            </>
          )}
        </StyledMenuOptions>
      )}
    </HamburgerMenuWrapper>
  )
}

export default HamburgerMenu
